/**
 * @private
 * @deprecated Analytics event names should use camelCase, therefore AnalyticsKeys should no longer be used or expanded.
 */
export const AnalyticsKeys = {
	ACTIVITY_ALL_VIEW: 'activity.all.view',
	ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
	HISTORY_VIEW: 'history.view',
	PEOPLE_VIEW: 'people-search.view',
	PROFILE_PAGE_VIEW: 'profile-page.view',
	AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
	PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
	PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
	PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
	PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
	PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
	PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
	PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
	PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
	PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW:
		'profile-settings.security.two-step-verification.view',
	PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
	PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
	PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
	TEAM_PROFILE_VIEW: 'team-profile.view',
	KUDOS_PAGE_VIEW: 'kudos-page.view',
	TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
	ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',

	// TODO: remove these once we move to a new analytics platform
	LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view',
};

export const analyticsKeyToEventMap: {
	[AnalyticsKeys.PROFILE_PAGE_VIEW]: string;
	[AnalyticsKeys.TEAM_PROFILE_BROWSE_ALL]: string;
} = {
	[AnalyticsKeys.PROFILE_PAGE_VIEW]: 'userProfile',
	[AnalyticsKeys.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage',
};

export enum AnalyticsEventSource {
	// `/people/<userId>` page
	USER_PROFILE_SCREEN = 'userProfileScreen',
	USER_PROFILE_ABOUT = 'userProfileAbout',

	// `/people/<userId>/work` page
	USER_WORK_SCREEN = 'userWorkScreen',

	// `/people/agent/<agentId>` page
	AGENT_PROFILE_SCREEN = 'agentProfileScreen',
	AGENT_DELETE_SUCCESS_FLAG = 'agentDeletedSuccessflag',
	AGENT_DELETE_ERROR_FLAG = 'agentDeletedErrorflag',

	// `/people/team/<teamId>` page
	TEAM_PROFILE_SCREEN = 'teamProfileScreen',
	TEAM_PROFILE_ABOUT = 'teamProfileAbout',
	TEAM_RESTORE_SCREEN = 'teamRestoreScreen',
	TEAM_RESTORE_SUCCESS_FLAG = 'teamReactivatedSuccessflag',
	TEAM_RESTORE_ERROR_FLAG = 'teamReactivatedErrorflag',

	CREATE_TEAM_MODAL = 'createTeamModal',

	TEAM_LINKS_REACH_LIMIT_FLAG = 'teamLinksReachLimitFlag',

	// `/people/search` page
	DIRECTORY_SCREEN = 'directoryScreen',

	// new `/people/search` page
	PEOPLE_HOME = 'peopleHome',

	PEOPLE_DRAWER = 'peopleDrawer',

	// inside avatar menu
	USER_MENU = 'userMenu',

	// experimentLeaf */
	ADD_PEOPLE_MODAL = 'addPeopleModal',

	// generic metrics
	CLIENT_METRICS = 'clientMetrics',

	// generic metrics
	DIRECTORY_APP = 'directoryApp',

	INITIALS_DIALOG = 'avatarInitialsPicker',

	// /people/kudos/:uuid
	KUDOS_SCREEN = 'kudos',

	PROFILE_CARD = 'profilecard',

	// new `/people/search/teams` page
	TEAMS_PAGE = 'teamsPage',
}

export enum AnalyticsEventActions {
	ACCEPTED = 'accepted',
	CLICKED = 'clicked',
	CLOSED = 'closed',
	COLLAPSED = 'collapsed',
	CREATED = 'created',
	DECLINED = 'declined',
	DELETED = 'deleted',
	EDITED = 'edited',
	EXPANDED = 'expanded',
	EXPOSED = 'exposed',
	FAILED = 'failed',
	JOINED = 'joined',
	REDIRECTED = 'redirected',
	REMOVED = 'removed',
	SENT = 'sent',
	SORTED = 'sorted',
	STARTED = 'started',
	OPENED = 'opened',
	SHOWN = 'shown',
	SUBMITTED = 'submitted',
	SUCCEEDED = 'succeeded',
	TRIGGERED = 'triggered',
	TYPED = 'typed',
	VIEWED = 'viewed',
	MOUNTED = 'mounted',
	MOVED = 'moved',
	DRAGGED = 'dragged',
	SELECTED = 'selected',
	LINKED = 'linked',
}

export enum AnalyticsEventSubjects {
	TEAM_LINK = 'teamLink',
	BUTTON = 'button',
	MODAL_DIALOG = 'modalDialog',
	FORM = 'form',
	ERROR = 'error',
}
